<svelte:options customElement={{
  tag: 'svg-icon',
  shadow: 'none',
  props: {
    name: { reflect: true, type: 'String' },
    size: { reflect: true, type: 'String' },
    fill: { reflect: true, type: 'String' },
    sprite: { reflect: true, type: 'String' }
  }
}} />

<script>
  /**
   * SVGアイコン
   * パーツライブラリ準拠のSVGスプライト使用
   * @prop {string} name - アイコン名:
   *   arrow, arrow_bottom, arrow_left, arrow_left_double, arrow_right, arrow_right_double, arrow_top,
   *   blank, cation, check, close, contact, dehaze, document, download, expand_circle_right,
   *   favorite, freedial, lang, map, marker_disc, minus, movie, pdf, play, plus, search, stop, tel,
   *   sns_facebook, sns_facebook_color, sns_instagram, sns_instagram_color,
   *   sns_line, sns_line_color, sns_linkedin, sns_linkedin_color,
   *   sns_x, sns_x_color, sns_youtube, sns_youtube_color,
   *   sns_youtube_2, sns_youtube_2_color
   * @prop {string} size - サイズ: 'sm' (12px), 'md' (16px), 'lg' (24px), 'xl' (32px)
   * @prop {string} fill - アイコン色（hex: '#ff0000', rgb: 'rgb(255,0,0)', rgba: 'rgba(255,0,0,0.5)'）
   * @prop {string} sprite - スプライトパス（デフォルト: /common/svg/sprite.svg）
   */
  export let name = '';
  export let size = 'md';
  export let fill = '';
  export let sprite = '/common/svg/sprite.svg';

  $: wrapClass = size ? `icon-${size}` : '';
  $: href = name ? `${sprite}#${name}` : '';
  $: colorStyle = fill ? `color: ${fill}` : '';
</script>

{#if name}
  <span class={wrapClass} style={colorStyle} aria-hidden="true">
    <svg>
      <use xlink:href={href} />
    </svg>
  </span>
{/if}
